import React, { FC } from 'react';

import { IVehicle } from '@/app/state/app/registers/vehicles';

import Translator from '../../../helpers/TranslationHelper';
import GroupsList from '../_shared/GroupsList';
import { useHistory } from 'react-router-dom';
import { RouteVehicleEditPage } from '@/app/pages/paths';

interface IProps {
    vehicle: IVehicle;
    onAssign?: (vehicle: IVehicle) => void;
}

const VehicleRow: FC<IProps> = ({ vehicle, onAssign }) => {
    const history = useHistory();

    const handleEditClick = () => {
        history.push(
            RouteVehicleEditPage.replace(':id', vehicle.externalId.toString()) +
                `?returnUrl=${encodeURIComponent(
                    history.location.pathname + history.location.search
                )}`
        );
    };

    const handleAssignClick = () => {
        if (onAssign) {
            onAssign(vehicle);
        }
    };

    const renderGroups = () => {
        const groups = vehicle.groups;
        if (groups) {
            return <GroupsList groups={groups} />;
        }
        return null;
    };

    const _renderActions = () => {
        return (
            <td>
                <button
                    className="button button-link"
                    onClick={handleEditClick}
                >
                    <span className="icon icon-pencil2"> </span>
                    {Translator.translate('Edit')}
                </button>
                <button
                    className="button button-link"
                    onClick={handleAssignClick}
                >
                    <span className="icon icon-add-card"> </span>
                    {Translator.translate('Assigning cards')}
                </button>
            </td>
        );
    };

    let cards = null;
    if (vehicle.cards) {
        cards = vehicle.cards.map((card, idx) => (
            <div key={idx}>
                {card.cardNumber} <br />
            </div>
        ));
    }

    return (
        <tr>
            <td className="column">{vehicle.name}</td>
            <td className="column">{renderGroups()}</td>
            <td className="column">{vehicle.plateNumber}</td>
            <td className="column">{vehicle.sideNumber}</td>
            <td className="column">{cards}</td>
            <td className="column">
                {vehicle.timeZone && vehicle.timeZone.name}
            </td>
            {_renderActions()}
        </tr>
    );
};

export default VehicleRow;
